var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivateCondominium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.07136 3.63212H15.9285M8.07136 3.63212V21.2857H15.9285V3.63212M8.07136 3.63212L7.60295 2.91455C7.46649 2.7055 7.61648 2.42847 7.86613 2.42847H16.1338C16.3834 2.42847 16.5334 2.7055 16.3969 2.91455L15.9285 3.63212",
    stroke: "#BF9A6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.81482 7.84125H8.33336M1.81482 7.84125V20.9715C1.81482 21.145 1.95553 21.2857 2.1291 21.2857H8.01908C8.19265 21.2857 8.33336 21.145 8.33336 20.9715V7.84125M1.81482 7.84125L1.32575 7.10764C1.18651 6.89878 1.33623 6.61902 1.58725 6.61902H8.01908C8.19265 6.61902 8.33336 6.75973 8.33336 6.93331V7.84125",
    stroke: "#BF9A6D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6666 7.84125H22.1852M15.6666 7.84125V20.9715C15.6666 21.145 15.8073 21.2857 15.9809 21.2857H21.8709C22.0445 21.2857 22.1852 21.145 22.1852 20.9715V7.84125M15.6666 7.84125V6.93331C15.6666 6.75973 15.8073 6.61902 15.9809 6.61902H22.4127C22.6638 6.61902 22.8135 6.89878 22.6742 7.10764L22.1852 7.84125",
    stroke: "#BF9A6D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.4286,
    y: 15.3929,
    width: 3.14287,
    height: 5.50002,
    rx: 0.157143,
    stroke: "#BF9A6D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.4286,
    y: 5.17859,
    width: 3.14287,
    height: 1.57143,
    rx: 0.157143,
    stroke: "#BF9A6D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 9.89282,
    width: 3.14287,
    height: 1.57143,
    rx: 0.157143,
    stroke: "#BF9A6D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3.3158,
    y: 9.89282,
    width: 3.14287,
    height: 1.57143,
    rx: 0.157143,
    stroke: "#BF9A6D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 10.4286,
    y: 8.38342,
    width: 3.14287,
    height: 1.57143,
    rx: 0.157143,
    stroke: "#BF9A6D"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 10.4286,
    y: 11.8572,
    width: 3.14287,
    height: 1.57143,
    rx: 0.157143,
    stroke: "#BF9A6D"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 13.5941,
    width: 3.14287,
    height: 1.57143,
    rx: 0.157143,
    stroke: "#BF9A6D"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 3.3158,
    y: 13.5941,
    width: 3.14287,
    height: 1.57143,
    rx: 0.157143,
    stroke: "#BF9A6D"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 17.0676,
    width: 3.14287,
    height: 1.57143,
    rx: 0.157143,
    stroke: "#BF9A6D"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 3.3158,
    y: 17.0676,
    width: 3.14287,
    height: 1.57143,
    rx: 0.157143,
    stroke: "#BF9A6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivateCondominium);
export default __webpack_public_path__ + "static/media/private_condominium.7dbefadb7d67e9e17917c01795edb552.svg";
export { ForwardRef as ReactComponent };